<template>
  <div class="br-pagebody pd-x-20 pd-sm-x-30">
    <div class="card bd-gray-400">
      <table class="table mg-b-0 table-contact bill data-table">
        <thead>
          <tr>
            <th class=" wd-450">{{$t("order.商品信息")}}</th>
            <th class=" tx-center">
              <a class="hover-info" :class="sortType == 2 ? 'tx-info' : 'tx-gray-500'" href="javascript:;"
              @click="sortItem(2)">
                {{$t("order.销量7天")}}<span class=" mg-l-5 mg-r-15 sp-dd"></span>
              </a> / 
              <a class=" hover-info" :class="sortType == 1 ? 'tx-info' : 'tx-gray-500'"  href="javascript:;"
              @click="sortItem(1)">
                {{$t("order.销量30天")}}<span class=" mg-l-5 mg-r-15 sp-dd"></span>
              </a>
            </th>
            <th>{{$t("order.上次采购情况")}}</th>
            <th class=" tx-center">{{$t("order.平均单次采购量(件)")}}</th>
            <th class=" tx-center">{{$t("order.平均采购周期(天)")}}</th>
            <th class=" tx-center">
              {{$t("order.日均销量(件)")}}
              <!-- <i data-toggle="tooltip-primary" data-placement="top" data-original-title="近期销量去除最高和最低值之后的平均值" class="col-form-label ion-ios-help-outline tx-16 tx-info"></i> -->
            </th>
          </tr>
        </thead>
        <tbody class=" tx-12">
          <tr v-for="(item, index) in items" :key="item.sku">
            <td>
              <div class="pro">
                <a class="img-wrap mg-r-15" style="background-size: cover;"
                 v-lazy:background-image="item.imgUrl"
                 href="javascript:;" @click="preview(item.imgUrl,  item.name)">
                </a>
                <div class="info">
                  <div class=" mg-b-5 tx-white tx-ellipsis2">{{item.name}}</div>
                  <div class=" mg-b-1">
                    <span>SKU:</span>
                    <span class=" tx-white mg-r-5">{{item.sku}}</span>
                    <a
				                        v-show="item.sku"
				                        class="to-clipboard tx-info mg-l-5"
				                        href="javascript:;"
				                        :data-clipboard-text="item.sku"
				                      >
				                        <i class="icon ion-clipboard"></i>
				                      </a>
                  </div>
                  <div v-if="item.name != item.propertyValue">
                    <span>{{$t("order.属性:")}}</span>
                    <span class=" tx-white">{{item.propertyValue}}</span>  
                  </div>
                </div>
              </div>
            </td>
            <td class=" valign-middle tx-center">
              <a class=" mg-r-5 tx-info" href="javascript:;" @click="openCharts(item, 1)">{{item.salesCnt7}} <i class="icon ion-stats-bars"></i></a> 
               / 
              <a class="mg-l-10 mg-r-5 tx-info" href="javascript:;" @click="openCharts(item, 2)">{{item.salesCnt30}} <i class="icon ion-stats-bars"></i></a>
            </td>
            <td>
              <div class=" mg-b-5">{{$t("order.采购量：")}}<span class=" tx-white">{{item.saleLastPurchased}}</span></div>
              <div>{{$t("order.采购时间：")}}<span class=" tx-white">{{item.timeLastPurchased | dateFormat}}</span></div>
            </td>
            <td class=" valign-middle tx-center">
              <span class=" tx-14 tx-white">{{item.averagePurchased}}</span>
            </td>
            <td class=" valign-middle tx-center">
              <span class=" tx-14 tx-white">{{item.averageDays}}</span>
            </td>
            <td class=" valign-middle tx-center">
              <span class=" tx-14 tx-white">{{item.forecastSale}}</span>
            </td>
          </tr>
          <tr v-if="(!items || items.length < 1) && !first_loading">
            <td colspan="6">
              <div class="col-12 none-product">
                <i class="fa fa-ban"></i>{{$t("order.没有符合条件的商品报表")}}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>  
</template>

<script>
export default {
  props: ["first_loading", "items", "sortType"],
  filters:{
    dateFormat(val){
      return moment(val, 'YYYYMMDD').format('YYYY-MM-DD')
    }
  },
  methods: {
  	preview(img, text) {
      this.$store.commit("setImgItem", [
        {
          img,
          text
        }
      ]);
      this.$parent.loading = true;
      setTimeout(() => {
        const viewer = document.querySelector(".app-images-arr").$viewer;
        if (viewer.images.length) viewer.show();
        this.$parent.loading = false;
      }, 500);
    },
    openCharts(item, type){
      this.$emit('openCharts', item, type);
    },
    sortItem(sortType){
      if(sortType == this.sortType) return;
      this.$emit('sortItem', sortType);
    }
  },
  updated(){
    $('[data-toggle="tooltip-primary"]').tooltip({
      template:
        '<div class="tooltip tooltip-primary" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
    });
  }
}
</script>

<style lang="less" scoped>
.pro{
  display: flex;
  max-width: 450px;
  .img-wrap{
    border: 1px #ddd solid;
    width: 80px;
    height: 80px;
    min-width: 80px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
}
</style>


